module.exports = __webpack_public_path__ + "assets/a9790a4f2a4fc9ce3ef282f79db9368c.mp3";